"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const api_1 = __importDefault(require("../api"));
const authentication_1 = require("../api/authentication");
const LOCAL_DEV = !!process.env.LOCAL_DEV;
const useAuthentication = () => {
    const [authentication, setAuthentication] = react_1.default.useState(null);
    react_1.default.useEffect(() => {
        const getAuthState = () => __awaiter(void 0, void 0, void 0, function* () {
            // There isn't a logged-in Cognito entity when running in local development mode
            if (LOCAL_DEV) {
                setAuthentication({ authenticated: true, admin: false });
                return;
            }
            const user = yield api_1.default.authentication.getCurrentUser();
            const groups = yield api_1.default.authentication.getUserGroups(user);
            setAuthentication({
                authenticated: true,
                admin: groups.indexOf(authentication_1.UserGroups.ADMIN) >= 0
            });
        });
        getAuthState();
    }, []);
    return authentication;
};
exports.default = useAuthentication;
//# sourceMappingURL=useAuthentication.js.map